import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { QueryKey } from '../../api/hooks/types';

export const useInvalidateBonusesInfinite = () => {
	const client = useQueryClient();

	return useCallback(() => {
		client.invalidateQueries([QueryKey.BonusesInfinite]);
	}, [client]);
};
